import React from 'react';

import PropTypes from 'prop-types';
import LazyLoad from 'react-lazyload';

import { Row } from '@zillow/zrs-comet';

import PropertyCard from 'app/shared/components/soh/PropertyCard';

import { StyledCol } from './StyledComponents';

const propTypes = {
    listings: PropTypes.array.isRequired,
};

const PropertiesViewGrid = ({ listings }) => {
    return (
        <Row className="PropertiesViewGrid">
            {listings.map((listingModel, index) => {
                const {
                    feedListingId,
                } = listingModel;

                return (
                    <StyledCol
                        className="PropertiesDisplay-StyledCol"
                        xs={12}
                        lg={6}
                        xl={4}
                        key={index}
                    >
                        <LazyLoad
                            height={262}
                            once={true}
                        >
                            <PropertyCard
                                key={feedListingId}
                                listing={listingModel}
                            />
                        </LazyLoad>
                    </StyledCol>
                );
            })}
        </Row>
    );
};

PropertiesViewGrid.propTypes = propTypes;

export { PropertiesViewGrid };
export default PropertiesViewGrid;
